if (!customElements.get("product-form-snippet")) {
  customElements.define(
    "product-form-snippet",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector(".form-sub-product");
        this.button = this.form.querySelector(".sub-product-button");
        this.button.addEventListener("click", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") || document.querySelector("cart-drawer");
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        let formDataArr = [];

        const customProducts = document.querySelectorAll(
          ".product__info-sub-product:not(.disabled)"
        );
        const mainProductID = document.querySelector(".main-product-variant-id").value;
        const mainProductPrice = document.querySelector(".main-product-variant-price").value;
        const subProducts = document.querySelectorAll(".innerproduct__wrap input:checked");
        let customizedPrice = parseFloat(mainProductPrice);


        const uniqueKey = Date.now().toString();


        const mainProductItem = {
          id: mainProductID,
          quantity: 1,
          properties: {
            _isSubProduct: "isSubProduct",
            _unique: uniqueKey,
          },
        };

        formDataArr.push(mainProductItem);

        customProducts.forEach((product, index) => {
          const variantID = product.querySelector('[name="id"]').value;
          const innerField = product.querySelector(
            ".variant-field-info:not(.visually-hidden)"
          );

          let innerFieldValue = "";
          let innerFieldTitle = "";

          if (innerField != null) {
            innerFieldValue =
              innerField.querySelector(".variant-properties")?.value || "";
            innerFieldTitle =
              innerField.querySelector(".variant-field-info--title")?.innerText ||
              "";
          }

          const scriptTag = product.querySelector('script[type="application/json"]');
          let nameText = "";
          let priceText = "";

          if (scriptTag) {
            const variants = JSON.parse(scriptTag.textContent);
            nameText = variants.find(v => v.id == variantID)?.name || "";
            priceText = variants.find(v => v.id == variantID)?.price || "0.00";
            customizedPrice += parseFloat(priceText);
          }

          if (variantID.length > 0) {
            let productArr = {
              id: variantID,
              quantity: 1,
              properties: {
                _hasSubProduct: "hasSubProduct",
                _mainProductID: mainProductID,
                _unique: uniqueKey,
                _nameText: nameText,
                _priceText: priceText,
              },
            };

            if (innerField != null && innerFieldValue.length > 0) {
              productArr.properties.addInfo = `${innerFieldTitle}: ${innerFieldValue}`;
            }

            formDataArr.push(productArr);

            if (productArr.properties.addInfo) {
              mainProductItem.properties[`addInfo_${index + 1}`] =
                productArr.properties.addInfo;
            }

            mainProductItem.properties[`_custom_${nameText}`] = priceText;
          }
        });

        if (subProducts.length > 0) {
          subProducts.forEach((product, index) => {
            const variantID = product.dataset.variantid;
            const subproductArr = {
              id: variantID,
              quantity: 1,
            };
            formDataArr.push(subproductArr);

            const label =
              product.dataset.title ||
              product.getAttribute("aria-label") ||
              product.value ||
              `SubProduct ${index + 1}`;

            mainProductItem.properties[`checkedSubProduct_${index + 1}`] =
              `${label} (variant: ${variantID})`;
          });
        }

        mainProductItem.properties._custom_price = customizedPrice.toFixed(2);

        let formData = {
          items: formDataArr,
          sections: this.cart.getSectionsToRender().map((section) => section.id),
          sections_url: window.location.pathname,
        };

        fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            this.error = false;
            this.cart.renderContents(response);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(".product-form__error-message");

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

document.querySelectorAll('details').forEach((details) => {
  details.addEventListener('toggle', (event) => {
    if (details.open) {
      document.querySelectorAll('details[open]').forEach((openDetails) => {
        if (openDetails !== details) {
          openDetails.removeAttribute('open');
        }
      });
      setTimeout(() => {
        details.scrollIntoView({
          behavior: "smooth",
          block: "top"
        });
      }, 250)
    }
  });
});
